<!-- eslint-disable vuejs-accessibility/no-redundant-roles -->
<template>
  <tr
    role="row"
    @mouseenter="e => $emit('row-hovered', e)"
    @focusin="e => $emit('row-hovered', e)"
    @mouseleave="e => $emit('row-unhovered', e)"
    @focusout="e => $emit('row-unhovered', e)"
  >
    <slot />
  </tr>
</template>

